import React, { ReactElement } from 'react'
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'

interface FieldSetProps {
  children: ReactElement | ReactElement[]
  fieldStyle?: StyleProp<ViewStyle>
}

export default function ({ children, fieldStyle }: FieldSetProps) {
  return (
    <View style={
      StyleSheet.compose({ marginTop: 10, marginBottom: 10 }, fieldStyle)
    }>
      { children }
    </View>
  )
}
